import { z } from "@core/zod";

import { TextContentSchema } from "./text-content.ts";

export const RevisionContentSchema = z.discriminatedUnion("kind", [
  TextContentSchema,
]);
